import { v2 } from "../../utils/apiClients";

export const authService = {
  register: async (data, idempotencyKey) => {
    const response = await v2.post("/authentication/register", data, {
      headers: {
        "Idempotency-Key": idempotencyKey,
      },
    });
    return response.data;
  },
  verifyEmail: async (data) => {
    const response = await v2.post("/authentication/verifyEmail", data);
    return response.data;
  },
  resendVerificationCode: async (data, idempotencyKey) => {
    const response = await v2.post(
      "/authentication/resendVerificationCode",
      data,
      {
        headers: {
          "Idempotency-Key": idempotencyKey,
        },
      },
    );
    return response.data;
  },
  login: async (data) => {
    const response = await v2.post("/authentication/login", data);
    return response.data;
  },
  resendTwoFactorCode: async (data, idempotencyKey) => {
    const response = await v2.post(
      "/authentication/resendTwoFactorCode",
      data,
      {
        headers: {
          "Idempotency-Key": idempotencyKey,
        },
      },
    );
    return response.data;
  },
  verifyCode: async (data) => {
    const response = await v2.post("/authentication/verify-2fa", data);
    return response.data;
  },
  forgotPassword: async (data, idempotencyKey) => {
    const response = await v2.post("/authentication/forgotPassword", data, {
      headers: {
        "Idempotency-Key": idempotencyKey,
      },
    });
    return response.data;
  },
  logout: async () => {
    const response = await v2.post("/authentication/logout");
    return response.data;
  },
  resetPassword: async (data) => {
    const response = await v2.post("/authentication/resetPassword", data);
    return response.data;
  },
  changePassword: async (data) => {
    const response = await v2.post("/authentication/changePassword", data);
    return response.data;
  },
  validatePin: async (data) => {
    const response = await v2.post("/authentication/validatePin", data);
    return response.data;
  },
};
